import { iconView } from '@common/_assets/images';
import React from 'react';
import { Button, Image } from 'react-bootstrap';

interface INotificationToastLinkBodyProps {
  linkText: string;
  linkUrl: string;
}

const navigateToLink = (linkUrl: string) => {
  window.open(linkUrl, '_blank');
};

const NotificationToastLinkBody: React.FC<INotificationToastLinkBodyProps> = ({
  linkText,
  linkUrl,
}) => (
  <Button className="action-button" onClick={() => navigateToLink(linkUrl)}>
    <div className="d-flex align-items-center">
      <Image src={iconView} style={{ filter: 'brightness(0) invert(1)' }} />
      <div className="action-button-text" style={{ color: 'white' }}>
        {linkText}
      </div>
    </div>
  </Button>
);

export default NotificationToastLinkBody;
